import React from 'react';
import { Field } from 'formik';
import CustomInputTextComponent from 'components/Form/CustomInputTextComponent';
import Select from "components/Form/Select";

const GeneralForm = ({errors, centers}) => {
	return (
	<div>
		<Field
			type='text'
			name='name'
			customlabel='Nom'
			component={CustomInputTextComponent}
			required
		/>
			<Field
			type='text'
			name='abbreviation'
			customlabel='Code'
			component={CustomInputTextComponent}
			required
		/>
		<Field
			type='text'
			name='liveCallNumber'
			customlabel="Numéro pour le système d'appels des patients en direct"
			component={CustomInputTextComponent}
		/>
	 <Field
            component={Select}
            name="center"
            customlabel="Centre"
            placeholder='Sélectionner un centre'
            options={centers ? centers.map(c => {return {value : c.id, label: c.name}}).sort((a, b) => a.label.localeCompare(b.label)) : []} 
            errors={errors}
        />
	</div>)
};

export default GeneralForm;
